export default "__VITE_ASSET__Bs$R9AE9__"